import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "toggle", "toggleLabel", "query", "clear", "item", "group", "empty"]
  static values = { storageKey: String, label: String }

  connect() {
    this.groupStates = new Map()
    this.groupTargets.forEach(group => this.groupStates.set(group, group.dataset.defaultExpanded === "true"))
    this.filtering = false
    this.ready = false
    let hidden = false
    try { hidden = sessionStorage.getItem(this.storageKeyValue) === "hidden" } catch (_) { /* Storage is optional. */ }
    this.setMenuVisible(!hidden)
    this.filter()
    this.ready = true
  }

  toggle() {
    this.setMenuVisible(this.menuTarget.hidden)
    try { sessionStorage.setItem(this.storageKeyValue, this.menuTarget.hidden ? "hidden" : "visible") } catch (_) { /* The menu still works without storage. */ }
  }

  setMenuVisible(visible) {
    this.menuTarget.hidden = !visible
    this.element.classList.toggle("is-menu-hidden", !visible)
    this.toggleTarget.setAttribute("aria-expanded", visible.toString())
    this.toggleTarget.setAttribute("aria-label", `${visible ? "Hide" : "Show"} ${this.labelValue} menu`)
    this.toggleLabelTarget.textContent = visible ? "Hide menu" : "Show menu"
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()
    const filtering = query.length > 0
    if (filtering && !this.filtering && this.ready) {
      this.groupTargets.forEach(group => this.groupStates.set(group, group.querySelector(".catalog-menu-group-panel").classList.contains("show")))
    }
    this.itemTargets.forEach(item => { item.hidden = !item.dataset.search.includes(query) })
    this.groupTargets.forEach(group => {
      const visible = [...group.querySelectorAll("[data-catalog-navigation-target='item']")].some(item => !item.hidden)
      group.hidden = !visible
      if (filtering || this.filtering) this.setGroupExpanded(group, filtering ? visible : this.groupStates.get(group))
    })
    this.emptyTarget.hidden = this.itemTargets.some(item => !item.hidden)
    this.clearTarget.hidden = !filtering
    this.filtering = filtering
  }

  clear() {
    this.queryTarget.value = ""
    this.filter()
    this.queryTarget.focus()
  }

  setGroupExpanded(group, expanded) {
    const button = group.querySelector("[data-bs-toggle='collapse']")
    button.classList.toggle("collapsed", !expanded)
    button.setAttribute("aria-expanded", expanded.toString())
    group.querySelector(".catalog-menu-group-panel").classList.toggle("show", expanded)
  }
}
